/**
 * Global smooth scroll for CCLP landing pages.
 * Handles all in-page anchor links (a.js-smoothScroll and same-page #hash hrefs)
 * except cclp-header and cclp-sticky-cta (they bind their own handlers).
 */
(function () {
  var INIT_ATTR = 'data-cclp-page-smooth-scroll';

  function parseCssPx(value) {
    var n = parseFloat(value);
    return Number.isFinite(n) ? n : 0;
  }

  function stickyOffsetPx() {
    var template = document.body.getAttribute('data-template') || '';
    if (template === 'memorial-day-mini-sale-l' || template === 'memorial-day-mini-sale-p') {
      return 74;
    }

    var styles = window.getComputedStyle(document.body);
    var announcement = parseCssPx(styles.getPropertyValue('--cclp-announcement-height'));
    var header = parseCssPx(styles.getPropertyValue('--cclp-header-height'));
    if (!header) {
      header = window.matchMedia('(min-width: 1024px)').matches ? 75 : 70;
    }
    return announcement + header;
  }

  function findScrollTarget(hashId) {
    return window.CclpScrollTarget ? window.CclpScrollTarget.find(hashId) : null;
  }

  function isSmoothScrollLink(el) {
    if (!el || el.tagName !== 'A') return false;
    if (el.closest('cclp-header-section') || el.closest('cclp-sticky-cta')) return false;

    var href = el.getAttribute('href');
    if (!href || href === '#') return false;

    if (el.classList.contains('js-smoothScroll')) return true;
    return href.charAt(0) === '#';
  }

  function scrollToSection(elLink) {
    var href = elLink.getAttribute('href');
    if (!href || href.indexOf('#') === -1) return;

    var parts = href.split('#');
    var sectionId = parts.length > 1 ? parts[parts.length - 1] : '';
    if (!sectionId) return;

    var elSection = findScrollTarget(sectionId);
    if (!elSection) return;

    document.dispatchEvent(new CustomEvent('landing-header:close', { bubbles: true }));

    var rect = elSection.getBoundingClientRect();
    var scrollY = window.scrollY + rect.top - stickyOffsetPx();

    window.scroll({
      top: scrollY,
      left: 0,
      behavior: 'smooth',
    });
  }

  function onDocumentClick(ev) {
    var elLink = ev.target.closest('a');
    if (!isSmoothScrollLink(elLink)) return;

    ev.preventDefault();
    scrollToSection(elLink);
  }

  function init() {
    if (document.documentElement.hasAttribute(INIT_ATTR)) return;
    document.documentElement.setAttribute(INIT_ATTR, 'true');
    document.addEventListener('click', onDocumentClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
